export default {
  AUTH_REQUIRED: Symbol('authRequired'),
};
